import { render } from "./content-assessor.vue?vue&type=template&id=193cb6ad"
import script from "./content-assessor.vue?vue&type=script&lang=js"
export * from "./content-assessor.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__